// extracted by mini-css-extract-plugin
export default {"checkbox":"checkboxCellRenderer_checkbox__qrzD2"};